import { POST } from "../../index";

export const getRequestRepairList = (param) => POST("/v1/repair/getRequestRepairList", param);
export const insertRequestRepair = (param) => POST("/v1/repair/insertRequestRepair", param);
export const updateRequestRepair = (param) => POST("/v1/repair/updateRequestRepair", param);
export const deleteRequestRepair = (param) => POST("/v1/repair/deleteRequestRepair", param);

export const getRequestRepair = (param) => POST("/v1/repair/getRequestRepair", param);
export const getRepair = (param) => POST("/v1/repair/getRepair", param);
export const updateUrgeCount = (param) => POST("/v1/repair/updateUrgeCount", param);
export const updateRepairState = (param) => POST("/v1/repair/updateRepairState", param);
export const updateCloseTime = (param) => POST("/v1/repair/updateCloseTime", param);

export const getRepairList = (param) => POST("/v1/repair/getRepairList", param);
export const updateRepairUser = (param) => POST("/v1/repair/updateRepairUser", param);
export const insertRepair = (param) => POST("/v1/repair/insertRepair", param);
export const abandonRequestRepair = (param) => POST("/v1/repair/abandonRequestRepair", param);

export const getCarMessage = (param) => POST("/v1/car/getCarMessage", param);



